import React, { useState } from 'react';
import './ItemDetailModal.css';

const ItemDetailModal = ({ isOpen, onClose, hat, onTradeRequest, onModify }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  if (!isOpen || !hat) return null;

  // Prepare all images (main + additional)
  const allImages = [];
  if (hat.image_url) {
    allImages.push(hat.image_url);
  }
  if (hat.additional_images && hat.additional_images.length > 0) {
    allImages.push(...hat.additional_images);
  }

  const placeholderImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23f8f9fa'/%3E%3Cpath d='M200 150c-30 0-54-24-54-54s24-54 54-54 54 24 54 54-24 54-54 54zm0-90c-19.9 0-36 16.1-36 36s16.1 36 36 36 36-16.1 36-36-16.1-36-36-36z' fill='%23dee2e6'/%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23666' font-family='Arial, sans-serif' font-size='16'%3ENo Image%3C/text%3E%3C/svg%3E";

  return (
    <div className="item-detail-modal-overlay">
      <div className="item-detail-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
        
        <div className="item-detail-content">
          <div className="item-detail-image-section">
            {/* Main Image Display */}
            <div className="item-detail-main-image">
              <img 
                src={allImages.length > 0 ? allImages[currentImageIndex] : placeholderImage} 
                alt={hat.name}
                onError={(e) => {
                  e.target.src = placeholderImage;
                  e.target.onerror = null;
                }}
              />
              {hat.featured && (
                <div className="featured-badge-large">
                  <i className="fas fa-star"></i>
                  Featured
                </div>
              )}
            </div>
            
            {/* Image Thumbnails */}
            {allImages.length > 1 && (
              <div className="image-thumbnails">
                {allImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  >
                    <img 
                      src={image} 
                      alt={`${hat.name} ${index + 1}`}
                      onError={(e) => {
                        e.target.src = placeholderImage;
                        e.target.onerror = null;
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
            
          <div className="item-detail-info">
            <h2 className="item-detail-title">{hat.name}</h2>
            
            <div className="item-detail-description">
              <p>{hat.description || 'No description available'}</p>
            </div>
            
            <div className="item-detail-specs">
              <div className="spec-item">
                <span className="spec-label">Brand:</span>
                <span className="spec-value">{hat.brand || 'Unknown Brand'}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Size:</span>
                <span className="spec-value">{hat.size || 'N/A'}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Condition:</span>
                <span className="spec-value">{hat.condition || 'N/A'}</span>
              </div>
              {hat.material && (
                <div className="spec-item">
                  <span className="spec-label">Material:</span>
                  <span className="spec-value">{hat.material}</span>
                </div>
              )}
              {hat.color && (
                <div className="spec-item">
                  <span className="spec-label">Color:</span>
                  <span className="spec-value">{hat.color}</span>
                </div>
              )}
            </div>
            
            <div className="item-detail-actions">
              {onModify && (
                <button 
                  className="btn btn-primary btn-large"
                  onClick={() => onModify(hat)}
                >
                  <i className="fas fa-edit"></i>
                  Modify
                </button>
              )}
              <button 
                className="btn btn-secondary btn-large"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemDetailModal;

